import React from 'react';
import FlightSearch from '../../FlightSearch/components/container';

const styles = {
  heading: {
    textAlign: 'center',
  },
};

const HomepageSearch = props => (
  <div>
    <h4 style={styles.heading}>FlightStats Serves the Needs of On-the-go Travelers</h4>
    <FlightSearch
      {...props}
      title='Track a Flight'
      gaTitlePrefix='Home'
    />
  </div>
);

export default HomepageSearch;



// WEBPACK FOOTER //
// ./modules/Homepage/components/Search.js